(() => {
  if (customElements.get('filter-results')) {
    return;
  }

  class FilterResults extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onChangeHandler.bind(this));
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-btn-toggle]')) {
          this.toggleAttribute('open');
        }
      });
    }

    onChangeHandler() {
      const selectedOptionValues = Array.from(this.querySelectorAll('input:checked, input[data-price], select[name="sort_by"]')).map(element =>
      {
        if (element.tagName === 'SELECT') {
          return `sort_by=${element.value}`
        } else if (element.hasAttribute('data-price')){
          return `${element.name}=${element.value}`
        } else {
          return element.dataset.optionValue
        }
      });

      const queryString = selectedOptionValues.join('&');

      fetch(`${window.location.pathname}?section_id=${this.dataset.url}&${queryString}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        document.querySelector('filter-results').innerHTML = html.querySelector('filter-results').innerHTML
        window.history.replaceState(null, '', `${window.location.pathname}${this.dataset.terms || ''}${this.dataset.terms ? '&' : '?'}${queryString}`);
      })
    }
  }

  customElements.define('filter-results', FilterResults);
})();
